import * as Reducers from 'src/app/store/reducers';
import { Component, OnDestroy } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { versions } from 'src/environments/version';

@Component({
	selector: 'layout-auth',
	templateUrl: './auth.component.html',
	styleUrls: ['./auth.component.scss'],
})
export class LayoutAuthComponent implements OnDestroy {
	logo: string
	isGrayTopbar: boolean
	isCardShadow: boolean
	isSquaredBorders: boolean
	isBorderless: boolean
	authPagesColor: string

	isAuthorized: boolean

	public versions = versions;

	private subscription = new Subscription();

	constructor(private store: Store<any>) {
		this.subscription.add(this.store.pipe(select(Reducers.getSettings)).subscribe(state => {
			this.logo = state.logo
			this.isGrayTopbar = state.isGrayTopbar
			this.isCardShadow = state.isCardShadow
			this.isSquaredBorders = state.isSquaredBorders
			this.isBorderless = state.isBorderless
			this.authPagesColor = state.authPagesColor
		}));
		this.subscription.add(this.store.pipe(select(Reducers.getUser)).subscribe(state => {
			this.isAuthorized = state.authorized
		}));
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
}
